import React from "react";
import { Typography } from "@mui/material";
import ResponsiveDialog from "components/ResponsiveDialog";

export interface DialogProps {
	open: boolean;
	title: string;
	message: string | React.ReactNode;
	handleDialogClose: (
		isConfirm: boolean, // if true handle positive action else negative action
		isTitleCloseIconAction?: boolean // if true handle dialog title close icon click
	) => void;
	positiveActionText?: string;
	negativeActionText?: string;
	showActionButtons?: boolean;
	dialogActionContent?: React.ReactNode;
	showTitleCloseIcon?: boolean;
	disablePositiveButton?: boolean;
	showCloseButton?: boolean;
}

const ConfirmationDialog: React.FC<DialogProps> = ({
	open,
	title,
	message,
	handleDialogClose,
	positiveActionText = "Delete",
	negativeActionText = "Cancel",
	showActionButtons = true,
	dialogActionContent = undefined,
	showTitleCloseIcon = true,
	disablePositiveButton = false,
	showCloseButton = true,
}) => {
	return (
		<ResponsiveDialog
			open={open}
			maxWidth="xs"
			okText={positiveActionText}
			cancelText={negativeActionText}
			onConfirm={() => {
				handleDialogClose(true);
			}}
			onCancel={() => {
				handleDialogClose(false);
			}}
			onDialogClose={() => {
				handleDialogClose(false, true);
			}}
			title={title}
			showActionButtons={showActionButtons}
			dialogActionContent={dialogActionContent}
			titleCloseIcon={showTitleCloseIcon}
			disableOkButton={disablePositiveButton}
			showCloseBtn={showCloseButton}
		>
			<Typography variant="body1">{message}</Typography>
		</ResponsiveDialog>
	);
};
export default ConfirmationDialog;
